import { render, staticRenderFns } from "./searchArrq.vue?vue&type=template&id=3dd1b0e6"
import script from "./searchArrq.vue?vue&type=script&lang=js"
export * from "./searchArrq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports